import { render } from "./StaffGroupOps.vue?vue&type=template&id=2a49625c&scoped=true"
import script from "./StaffGroupOps.vue?vue&type=script&lang=js"
export * from "./StaffGroupOps.vue?vue&type=script&lang=js"

import "./StaffGroupOps.vue?vue&type=style&index=0&id=2a49625c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a49625c"]])

export default __exports__